<template>
  <div class="animated fadeIn col-md-12">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div slot="header">
            ایجاد
            <strong v-text="$lang.exercise_algorithm_detail"></strong>
          </div>

          <activityFrom
            :isLoading="isLoading"
            :showStateDefineCombo="false"
            :permissionBtn="true"
            @submit="save"
            @cancel="handleBack"
            :keyServies="`exercise`"
            @responseCode="getResponseCode"
          />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import activityFrom from "./../../../forms/activityFrom";
import { addAttachmentCode } from "@/components/ckeditor/submitAttachment";
export default {
  name: "add-exercise_algorithm_detail",
  components: {
    activityFrom,
  },
  inject: ["attachmentRepository"],
  props: {
    mode: {
      type: String,
      default: "add",
    },
    isModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      exercise_id: this.$route.params.id,
      algorithm_id: this.$route.params.algorithm_id,
      responseCode: [],
      attachmentId: null,
    };
  },
  methods: {
    getResponseCode(code) {
      this.responseCode = code;
    },
    handleBack() {
      if (this.backUrl) {
        this.$route.push(this.backUrl);
      } else if (this.isModal) {
        this.$emit("modal-end-up");
        // this.handleBack();
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    afterSave() {
      if (this.backUrl) {
        this.$router.push(this.backUrl);
      } else {
        this.handleBack();
      }
    },
    async finalSave() {
      try {
        if (this.responseCode.length == 0) return;
        let payload = {
          data: [],
        };
        let resize_avatar = false;
        for (const item of this.responseCode) {
          if (item.type.match("image")) {
            if (this.keyServies == "person") {
              resize_avatar = true;
            }
          }
          payload.data.push({
            code: item.code,
            resize_avatar: resize_avatar,
          });
        }
        let actionResource = "exercise";
        let actionkey = this.attachmentId;
        const result = await this.attachmentRepository.create(
          payload,
          actionResource,
          actionkey
        );
        this.$notify.success(result.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.afterSave();
      }
    },
    put(payload) {
      let id = this.attachmentId;
      this.$httpService
        .put(
          this.$config.api_url +
            this.$config.kanoon.activity
              .replace("{0}", "exercise_algorithm")
              .replace("{1}", this.algorithm_id) +
            `/${id}`,
          payload
        )
        .then(async (response) => {
          this.$notify.success(response.data.message);
        })
        .catch((error) => {
          this.$generateError(error);
        })
        .finally(() => {});
    },
    async save(payload, allowAddAttachmentCode = true) {
      try {
        this.isLoading = true;
        const response = await this.$httpService.post(
          this.$config.api_url +
            this.$config.kanoon.activity
              .replace("{0}", "exercise_algorithm")
              .replace("{1}", this.algorithm_id),
          payload
        );

        this.attachmentId = response.data.data.id;
        if (this.attachmentId) {
          await this.finalSave();
        }

        if (allowAddAttachmentCode) {
          let res = await addAttachmentCode(
            "exercise_algorithm",
            this.attachmentId,
            payload.description
          );
          if (res.fail_codes) {
            payload.description = res.description;
            await this.put(payload);
          }
          this.afterSave();
        } else {
          this.afterSave();
        }
        this.afterSave();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = true;
      }
    },
  },
  created() {
    this.isLoading = true;
  },
  watch: {},
};
</script>

<style lang="css">
.main .container-fluid {
  padding: 0 10px !important;
}
</style>
